import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, PauseCircle, XCircle, Percent, Zap, Share2, FlaskConical, User as UserIcon } from "lucide-react";

const BENEFITS = [
  { icon: Percent, key: "b1", en: "30% OFF at Summit Peptides", pt: "30% OFF na Summit Peptides", es: "30% OFF en Summit Peptides" },
  { icon: Zap, key: "b2", en: "Unlimited AI cycle generations", pt: "Ciclos IA ilimitados", es: "Ciclos IA ilimitados" },
  { icon: FlaskConical, key: "b3", en: "Custom peptide protocols", pt: "Protocolos personalizados", es: "Protocolos personalizados" },
  { icon: Share2, key: "b4", en: "Share cycles + PDF export + collaborators", pt: "Compartilhar, PDF, colaboradores", es: "Compartir, PDF, colaboradores" },
  { icon: UserIcon, key: "b5", en: "1-on-1 consultation booking", pt: "Consulta 1-a-1", es: "Consulta 1-a-1" },
];

const t = (language, en, pt, es) => language === "pt" ? pt : language === "es" ? es : en;

export function CancelConfirmDialog({ open, onOpenChange, language, onConfirmCancel, onPauseInstead, cancelling }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-zinc-950 border-red-500/40 max-w-lg" data-testid="cancel-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white flex items-center gap-2">
            <AlertTriangle className="w-6 h-6 text-amber-400" />
            {t(language, "Wait — you'll lose these benefits", "Espere — você perderá estes benefícios", "Espera — perderás estos beneficios")}
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="text-zinc-300 space-y-3 pt-2">
              <p>
                {t(language,
                  "Cancelling your membership means you'll lose access to:",
                  "Cancelar sua assinatura significa que você perderá acesso a:",
                  "Cancelar tu suscripción significa que perderás acceso a:")}
              </p>
              <ul className="space-y-2 pl-1">
                {BENEFITS.map((b) => {
                  const Icon = b.icon;
                  return (
                    <li key={b.key} className="flex items-center gap-2 text-sm">
                      <Icon className="w-4 h-4 text-amber-400 shrink-0" />
                      <span>{t(language, b.en, b.pt, b.es)}</span>
                    </li>
                  );
                })}
              </ul>
              <p className="text-sm text-amber-300 font-medium pt-2">
                💡 {t(language,
                  "Consider pausing instead — your benefits freeze and you can reactivate anytime with no re-charge.",
                  "Considere pausar — seus benefícios congelam e você pode reativar quando quiser sem nova cobrança.",
                  "Considera pausar — tus beneficios se congelan y puedes reactivar en cualquier momento sin nuevo cargo.")}
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel disabled={cancelling} data-testid="cancel-dialog-back">
            {t(language, "Keep Membership", "Manter Assinatura", "Mantener Suscripción")}
          </AlertDialogCancel>
          <Button
            onClick={onPauseInstead}
            disabled={cancelling}
            className="bg-amber-500 hover:bg-amber-400 text-black font-semibold"
            data-testid="cancel-dialog-pause-instead"
          >
            <PauseCircle className="w-4 h-4 mr-2" />
            {t(language, "Pause Instead", "Pausar em vez disso", "Pausar en su lugar")}
          </Button>
          <AlertDialogAction
            onClick={onConfirmCancel}
            disabled={cancelling}
            className="bg-red-600 hover:bg-red-500 text-white"
            data-testid="cancel-dialog-confirm"
          >
            <XCircle className="w-4 h-4 mr-2" />
            {t(language, "Yes, Cancel", "Sim, Cancelar", "Sí, Cancelar")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
